import { render, staticRenderFns } from "./HotelSettings.vue?vue&type=template&id=55f84cca"
import script from "./HotelSettings.vue?vue&type=script&lang=js"
export * from "./HotelSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports